<pace-fi-card>
    <div class="container py-5 py-md-0" *ngrxLet="userRole$ as userRole">
        <h1 [translate]="userRole === userRoleType.BIOMEDICAL ? 'PROTOCOL_TITLE_WEB' : 'PROTOCOL_TITLE'"></h1>
        <span translate="PROTOCOL_DESCRIPTION"></span>
        <form [formGroup]="protocolProvisionFormGroup">
            <div class="form-container row">
                <div class="form-group col-12 col-md-6" formGroupName="matSerialNumber">
                    <div class="form-control-item">
                        <label for="materialNumber" translate="PROTOCOL_LABEL_MATERIAL"></label>
                        <input
                            formControlName="materialNumber"
                            id="materialNumber"
                            (keyup.enter)="submitFormOnEnter()"
                            class="form-control"
                        />
                    </div>
                    <div class="form-control-item">
                        <label for="serialNumber" translate="PROTOCOL_LABEL_SERIAL"></label>
                        <input
                            formControlName="serialNumber"
                            id="serialNumber"
                            (keyup.enter)="submitFormOnEnter()"
                            class="form-control"
                        />
                    </div>
                </div>
                <div class="form-group col-12 col-md-6">
                    @if (userRole === userRoleType.BIOMEDICAL) {
                        <div class="form-control-item">
                            <p class="fs-5" translate="PROTOCOL_LABEL_SERVICE_ACTIVITY"></p>
                            <p class="text-center fs-6" translate="PROTOCOL_LABEL_MAINTENANCE"></p>
                        </div>
                    } @else {
                        <div class="form-control-item">
                            <label for="orderNumber" translate="PROTOCOL_LABEL_ORDER"></label>
                            <input
                                formControlName="orderNumber"
                                id="orderNumber"
                                (keyup.enter)="submitFormOnEnter()"
                                class="form-control"
                            />
                        </div>
                        @if ([userRoleType.SHS_EMPLOYEE, userRoleType.SERVICE_PARTNER].includes(userRole)) {
                            <div class="form-control-item">
                                <label for="orderNumber" translate="PROTOCOL_LABEL_SERVICE_ACTIVITY"></label>
                                <pace-forms-dropdown
                                    id="service-activity"
                                    [dropDownText]="
                                        dropDownSelectedValueText || ('PROTOCOL_DROPDOWM_BUTTON_TEXT' | translate)
                                    "
                                >
                                    @for (option of serviceActivityOptions | keyvalue; track option) {
                                        <li role="menuitem">
                                            <a (click)="onSelectionChange(option.value)" class="dropdown-item">
                                                {{ option.value }}
                                            </a>
                                        </li>
                                    }
                                </pace-forms-dropdown>
                            </div>
                        }
                    }
                </div>
            </div>
            <div class="form-container" *ngrxLet="isEquipmentsLoading$; let isLoading">
                <div class="d-md-block d-none">
                    <button
                        type="button"
                        class="btn btn-primary"
                        (click)="submitForm()"
                        [disabled]="disableSubmit || isLoading || !protocolProvisionFormGroup.valid"
                        translate="PROTOCOL_BUTTON_SUBMIT"
                    ></button>
                </div>
                <div class="col-8 d-md-none">
                    <button
                        type="button"
                        class="btn btn-primary btn-lg w-100"
                        (click)="submitForm()"
                        [disabled]="disableSubmit || isLoading || !protocolProvisionFormGroup.valid"
                        translate="PROTOCOL_BUTTON_SUBMIT"
                    ></button>
                </div>
            </div>
        </form>
    </div>
</pace-fi-card>
